import React from 'react'
import LayoutAdmin from '../../components/layout/LayoutAdmin'

const SAReports = () => {
  return (
    <LayoutAdmin>
      <h2 className="text-xl font-semibold mb-4">Super Admin - Reports</h2>
      <div className="bg-white border rounded p-4">This is a dummy Super Admin Reports page.</div>
    </LayoutAdmin>
  )
}

export default SAReports


